import { Inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ErrorHandlerService } from "@youm-front/utils/error-handler";
import { VERSION } from "@youm-front/utils/version";
import { firstValueFrom, interval } from "rxjs";
import { exhaustMap, tap } from "rxjs/operators";
import { LokiConfig, LOKI_CONFIG } from "../../providers";
import { LokiActions } from "../actions";
import { LokiPushDTO } from "../dto";
import { LokiService } from "../services";

@Injectable()
export class LokiEffects {
  private static readonly PUSH_INTERVAL_MS = 10_000;

  constructor(
    @Inject(LOKI_CONFIG) private readonly lokiConfig: LokiConfig,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly lokiService: LokiService,
    private readonly actions$: Actions
  ) {}

  errorHandler$ = createEffect(
    () =>
      this.errorHandlerService.error$.pipe(
        tap((_) =>
          this.lokiService.push({
            error: {
              name: _.error.name,
              message: _.error.message,
              stack: _.error.stack,
              errorId: _.error.errorId
            },
            errorId: _.errorId,
            version: VERSION
          })
        )
      ),
    { dispatch: false }
  );

  log$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LokiActions.log),
        tap((_) => this.lokiService.push([..._.args, { version: VERSION }]))
      ),
    { dispatch: false }
  );

  pushLog$ = createEffect(
    () =>
      interval(LokiEffects.PUSH_INTERVAL_MS).pipe(
        exhaustMap(() => this.pushLogs())
      ),
    { dispatch: false }
  );

  private async pushLogs() {
    const logs = this.lokiService.head();

    const stream = {
      stream: {
        container: this.lokiConfig.container
      },
      values: logs
    };

    await firstValueFrom(
      this.lokiService.lokiPush(
        new LokiPushDTO({
          streams: [stream]
        })
      )
    ).catch(() => {
      this.lokiService.unshift(logs);
    });
  }
}
